import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Apple, Download, Smartphone, CheckCircle } from 'lucide-react';

export default function IOSProfileDownload() {
  const handleDownload = () => {
    // Direct download link to the iOS profile
    window.location.href = '/api/ios-profile';
  };

  return (
    <Card data-testid="ios-profile-card" className="border-gray-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Apple className="w-5 h-5" />
          iPhone/iPad App Installation
        </CardTitle>
        <CardDescription>
          Installieren Sie FarbWelt als App auf Ihrem iOS-Gerät
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="bg-gray-50 rounded-lg p-4 space-y-3">
          <h4 className="font-medium text-sm">So funktioniert&apos;s:</h4>
          <ol className="text-sm text-gray-600 space-y-2">
            <li className="flex items-start gap-2">
              <span className="w-5 h-5 rounded-full bg-[#9B1B30] text-white flex items-center justify-center text-xs shrink-0">1</span>
              <span>Laden Sie das Profil herunter (Button unten)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="w-5 h-5 rounded-full bg-[#9B1B30] text-white flex items-center justify-center text-xs shrink-0">2</span>
              <span>Öffnen Sie <strong>Einstellungen</strong> auf Ihrem iPhone/iPad</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="w-5 h-5 rounded-full bg-[#9B1B30] text-white flex items-center justify-center text-xs shrink-0">3</span>
              <span>Tippen Sie auf <strong>&quot;Profil geladen&quot;</strong></span>
            </li>
            <li className="flex items-start gap-2">
              <span className="w-5 h-5 rounded-full bg-[#9B1B30] text-white flex items-center justify-center text-xs shrink-0">4</span>
              <span>Tippen Sie auf <strong>Installieren</strong></span>
            </li>
          </ol>
        </div>

        <div className="bg-green-50 rounded-lg p-3">
          <h4 className="font-medium text-sm text-green-800 mb-1 flex items-center gap-2">
            <CheckCircle className="w-4 h-4" />
            Vorteile der App
          </h4>
          <ul className="text-xs text-green-700 space-y-1">
            <li>• Dauerhaft angemeldet bleiben</li>
            <li>• App-Icon auf dem Homescreen</li>
            <li>• Vollbild-Ansicht ohne Browser-Leiste</li>
            <li>• Schnellerer Zugriff</li>
          </ul>
        </div>

        <Button 
          onClick={handleDownload}
          className="w-full btn-primary flex items-center justify-center gap-2"
          data-testid="download-ios-profile-btn"
        >
          <Download className="w-4 h-4" />
          Apple Profil herunterladen
        </Button>

        <p className="text-xs text-gray-500 text-center">
          Funktioniert mit iPhone und iPad (iOS 15+)
        </p>
      </CardContent>
    </Card>
  );
}
